/** @file stepValue: the value `steps` steps of a field away, scaled by the held modifiers. */
import { modifierScale, type StepModifiers } from './modifierScale';

/** `base + steps * step * modifierScale`, with float noise trimmed (0.1 + 0.2 is 0.3). */
export function stepValue(base: number, steps: number, step: number, m: StepModifiers): number {
  return Number((base + steps * step * modifierScale(m)).toPrecision(12));
}
